/*ABBOX_CART_FR_20261014*/
(function finish(){var rows=Array.from(document.querySelectorAll('#pn .pn-ligne-total')),r=rows.filter(function(x){return x.children.length===2&&x.children[0].textContent.trim()==='Livraison'&&x.children[1].textContent.trim()==='Offerte'});if(r.length!==1){console.error('ABBOX : ligne livraison panier inattendue');return}r[0].children[1].textContent='Offerte dans les pays desservis';var s=document.createElement('style');s.textContent='#pn .pn-photo{background-size:contain;background-repeat:no-repeat}#pn .pn-photo .pn-ruban{display:none}';document.head.appendChild(s)})();

(function () {
  var V = [
    { nom: 'P9 Ultra 2 · Casque noir', court: 'P9 · Noir', hex: '#1C1C22' },
    { nom: 'P9 Ultra 2 · Casque rouge', court: 'P9 · Rouge', hex: '#C23A3F' },
    { nom: 'S2000 Pro · Montre noire', court: 'S2000 · Noire', hex: '#2E2E33' },
    { nom: 'S2000 Pro · Montre argentée', court: 'S2000 · Argentée', hex: '#C9CBCF' }
  ];
  var choix = 0;
  var barre = document.getElementById('barre'), flotte = document.getElementById('barre-flotte');
  var past = document.getElementById('barre-pastilles'), nom = document.getElementById('barre-nom'), prix = document.getElementById('barre-prix');
  var bouton = document.getElementById('barre-ajout'), btxt = document.getElementById('barre-ajout-txt'), toast = document.getElementById('barre-toast');
  V.forEach(function (v, i) {
    var b = document.createElement('button'); b.type = 'button'; b.style.background = v.hex; b.setAttribute('aria-label', v.court);
    b.addEventListener('click', function () { choix = i; window.ABBOX_CHOIX && window.ABBOX_CHOIX(i); maj(); });
    past.appendChild(b);
  });
  function produit() { return window.ABBOX_SHOP.page === 'produit'; }
  function etat() { var c = window.ABBOX_ETAT && window.ABBOX_ETAT(); return c || null; }
  function maj() {
    var e = produit() ? etat() : null;
    var i = e && e.c != null ? e.c : choix;
    var petit = window.innerWidth < 480;
    nom.textContent = petit ? V[i].court : V[i].nom;
    prix.textContent = (e && e.prix ? e.prix : '34,90 €') + (petit ? '' : ' · livraison offerte');
    Array.prototype.forEach.call(past.children, function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    if (!bouton.classList.contains('ok')) btxt.textContent = petit ? 'Ajouter · ' + (e && e.prix ? e.prix : '34,90 €') : 'Ajouter au panier';
    choix = i;
  }
  var t;
  bouton.addEventListener("click",function(){
if(bouton.disabled||!window.ABBOX_PANIER)return;
var e0=produit()?etat():null,v=e0?e0.c:choix;
bouton.disabled=true;clearTimeout(t);toast.classList.remove("montre");bouton.classList.remove("ok");
window.ABBOX_PANIER.ajouter(v,e0?e0.l===1:!1,bouton).then(function(){
bouton.disabled=false;toast.textContent="Coffret "+V[v].nom+" ajouté au panier";toast.classList.add("montre");bouton.classList.add("ok");btxt.textContent="Ajouté ✓";
t=setTimeout(function(){toast.classList.remove("montre");bouton.classList.remove("ok");maj()},2200);
}).catch(function(){bouton.disabled=false;bouton.classList.remove("ok");toast.textContent="Ajout non confirmé. Vérifie le message dans ton panier.";toast.classList.add("montre");maj();t=setTimeout(function(){toast.classList.remove("montre")},4000)});
});
  // la barre suit le défilement : elle apparaît après l'accroche et se balance selon la vitesse
  var dernier = window.scrollY, vitesse = 0, decal = 0;
  function boucle() {
    var y = window.scrollY, dy = y - dernier; dernier = y;
    vitesse = vitesse * 0.8 + dy * 0.2;
    var cible = Math.max(-14, Math.min(14, vitesse * 0.9));
    decal += (cible - decal) * 0.12;
    flotte.style.transform = 'translateY(' + decal.toFixed(2) + 'px) rotate(' + (decal * 0.08).toFixed(2) + 'deg)';
    barre.classList.toggle('visible', produit() ? y > 120 : y > 520);
    maj();
    requestAnimationFrame(boucle);
  }
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(boucle);
  else { window.addEventListener('scroll', function () { barre.classList.toggle('visible', window.scrollY > 300); maj(); }); }
  maj();
})();
;

(function () {
  var V = [
    { nom: 'Coffret casque P9 Ultra 2 · Noir', photo: 'https://cdn.shopify.com/s/files/1/1029/0957/5490/files/P9-noir__P9-noir-coffret-ouvert-hero-v1.png?v=1791985927', court: 'P9 · Noir', hex: '#2B2A31', pt: '#1C1C22' },
    { nom: 'Coffret casque P9 Ultra 2 · Rouge', photo: 'https://cdn.shopify.com/s/files/1/1029/0957/5490/files/P9-rouge__P9-rouge-coffret-ouvert-hero-v2.png?v=1791985927', court: 'P9 · Rouge', hex: '#7A2229', pt: '#C23A3F' },
    { nom: 'Coffret écouteurs S2000 Pro · Noir', photo: 'https://cdn.shopify.com/s/files/1/1029/0957/5490/files/S2000-noir__01-coffret-ouvert-studio-v2.png?v=1791985431', court: 'S2000 · Noir', hex: '#2E2E33', pt: '#2E2E33' },
    { nom: 'Coffret écouteurs S2000 Pro · Argenté', photo: 'https://cdn.shopify.com/s/files/1/1029/0957/5490/files/S2000-argente__01-coffret-ouvert-studio-v2.png?v=1791985432', court: 'S2000 · Argenté', hex: '#6E727A', pt: '#C9CBCF' }
  ];
  var PRIX = 3490;
  var lignes = [];   // un élément par coffret payé : sa couleur
  var cadeaux = [];  // coffrets offerts : couleur choisie pour chacun
  var dernier = 0;
  var fond = document.getElementById('pn-fond'), pn = document.getElementById('pn'), liste = document.getElementById('pn-liste');
  function vignette(v, ruban) { return V[v].photo ? '<div class="pn-boite pn-photo" style="background-image: url(' + V[v].photo + ')">' + (ruban ? '<b class="pn-ruban"></b>' : '') + '</div>' : '<div class="pn-boite" style="background: ' + V[v].hex + '">' + (ruban ? '<b class="pn-ruban"></b>' : '') + 'AB/BOX</div>'; }
  function euros(c) { var e = Math.floor(c / 100), r = c % 100; return e + ',' + (r < 10 ? '0' : '') + r + ' €'; }
  function payes() { return lignes.length; }
  function caler() {
    var f = Math.floor(payes() / 2);
    while (cadeaux.length < f) cadeaux.push(dernier);
    while (cadeaux.length > f) cadeaux.pop();
  }
  function fusionner() {}
  function ouvrir() { pn.classList.add('ouvert'); fond.classList.add('ouvert'); pn.setAttribute('aria-hidden', 'false'); }
  function fermer() { pn.classList.remove('ouvert'); fond.classList.remove('ouvert'); pn.setAttribute('aria-hidden', 'true'); }
  fond.addEventListener('click', fermer);
  document.getElementById('pn-fermer').addEventListener('click', fermer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
  document.getElementById('pn-commander').addEventListener('click', function () {
    if (commandeEnCours || !payes()) return;
    commandeEnCours = true; actualiserCommande();
    synchro().then(function () {
      if (!panierPret || synchronisations) throw new Error('Panier modifié pendant la synchronisation');
      location.href = '/checkout';
    }).catch(function (error) { commandeEnCours = false; afficherErreur(error); actualiserCommande(); });
  });
  function puces(actif, choisir) {
    var w = document.createElement('div'); w.className = 'pn-puces';
    V.forEach(function (x, j) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pn-puce' + (j === actif ? ' on' : '');
      b.innerHTML = '<i style="background: ' + x.pt + '"></i>' + x.court;
      b.addEventListener('click', function () { choisir(j); });
      w.appendChild(b);
    });
    return w;
  }
  function changer() { fusionner(); caler(); dessiner(); compteur(); synchro(); }
  var IDS=window.ABBOX_SHOP.ids,enCours=Promise.resolve(),synchronisations=0,synchroVersion=0,panierPret=false,commandeEnCours=false;
function actualiserCommande(){
var b=document.getElementById("pn-commander"),express=document.getElementById("pn-express");
b.disabled=!payes()||commandeEnCours||synchronisations>0;
document.getElementById("pn-commander-txt").textContent=commandeEnCours?"Vérification du panier…":synchronisations?"Mise à jour du panier…":payes()?"Passer commande · "+euros(payes()*PRIX):"Passer commande";
if(express){var bloque=!panierPret||synchronisations>0||commandeEnCours;express.inert=bloque;express.setAttribute("aria-disabled",String(bloque));express.style.pointerEvents=bloque?"none":"";express.style.opacity=bloque?"0.5":""}
}
function afficherErreur(error){
var n=document.getElementById("pn-erreur");
if(!n){n=document.createElement("p");n.id="pn-erreur";n.setAttribute("role","alert");n.style.cssText="margin:12px 0;color:#ffb9b1;font:600 14px/1.5 Manrope,system-ui,sans-serif";var b=document.getElementById("pn-commander");b.parentNode.insertBefore(n,b)}
n.textContent=error&&error.abboxMessage||"Le panier n’a pas pu être mis à jour. Réessaie avant de passer commande.";n.hidden=false;
}
function effacerErreur(){var n=document.getElementById("pn-erreur");if(n){n.textContent="";n.hidden=true}}
function requetePanier(url,options){
return fetch(url,options).then(function(r){
if(!r.ok){var e=new Error("HTTP "+r.status);e.abboxMessage=r.status===400||r.status===422?"Un coffret n’a pas pu être ajouté. Vérifie les quantités et réessaie.":"Le panier est momentanément indisponible. Réessaie dans quelques instants.";throw e}
return r.json();
},function(){var e=new Error("Réseau indisponible");e.abboxMessage="Connexion interrompue. Vérifie ta connexion puis réessaie.";throw e});
}
function synchro(){
var q={};IDS.forEach(function(id){q[id]=0});lignes.concat(cadeaux).forEach(function(v){q[IDS[v]]+=1});
var corps={updates:q};try{var mot=sessionStorage.getItem("abbox-mot");mot&&(corps.attributes={"Petit mot":mot})}catch(e){}
var H={"Content-Type":"application/json",Accept:"application/json"},version=++synchroVersion;
synchronisations++;panierPret=false;effacerErreur();actualiserCommande();
var operation=enCours.catch(function(){}).then(function(){return requetePanier("/cart.js",{headers:H})}).then(function(c){
var maj={},ajout=[];IDS.forEach(function(id){var l=(c.items||[]).filter(function(it){return it.variant_id===id});l.length?l.forEach(function(it,n){maj[it.key]=n===0?q[id]:0}):q[id]>0&&ajout.push({id:id,quantity:q[id]})});
var envoi={updates:maj};if(corps.attributes)envoi.attributes=corps.attributes;
return requetePanier("/cart/update.js",{method:"POST",headers:H,body:JSON.stringify(envoi)}).then(function(){if(ajout.length)return requetePanier("/cart/add.js",{method:"POST",headers:H,body:JSON.stringify({items:ajout})})});
}).then(function(result){synchronisations--;if(version===synchroVersion){panierPret=true;effacerErreur()}actualiserCommande();return result},function(error){synchronisations--;if(version===synchroVersion){panierPret=false;afficherErreur(error);ouvrir()}actualiserCommande();throw error});
enCours=operation;operation.catch(function(){});return operation;
}
requetePanier("/cart.js",{headers:{Accept:"application/json"}}).then(function(c){
if(synchroVersion!==0)return;
var unites=[];(c.items||[]).forEach(function(it){var v=IDS.indexOf(it.variant_id);if(v>=0)for(var n=0;n<it.quantity;n++)unites.push(v)});
var f=Math.floor(unites.length/3);lignes=unites.slice(0,unites.length-f);cadeaux=unites.slice(unites.length-f);if(unites.length)dernier=unites[unites.length-1];panierPret=true;dessiner();compteur();actualiserCommande();
}).catch(function(error){if(synchroVersion===0){panierPret=false;afficherErreur(error);actualiserCommande()}});
  function dessiner() {
    var p = payes(), f = cadeaux.length, anime = !pn.classList.contains('ouvert');
    liste.innerHTML = '';
    if (!p) liste.innerHTML = '<div id="pn-vide"><span class="fr" style="font-size: 20px">Ton panier est vide.</span><span class="fr" style="font-size: 15px">Choisis ton coffret, on s’occupe du reste.</span></div>';
    lignes.forEach(function (v, k) {
      var d = document.createElement('div'); d.className = 'pn-ligne' + (anime ? '' : ' fixe');
      d.innerHTML = '<div class="pn-haut">' + vignette(v, false) +
        '<div class="pn-infos">' + (p > 1 ? '<span class="pn-num">Coffret ' + (k + 1) + '</span>' : '') + '<span class="fr">' + V[v].nom + '</span><span class="fr pn-prix">' + euros(PRIX) + ' · prêt à offrir</span></div>' +
        '<button type="button" class="pn-suppr" aria-label="Retirer ce coffret">×</button></div>' +
        '<span class="fr pn-choix">' + (p > 1 ? 'Choisis ton coffret ' + (k + 1) : 'Choisis ton coffret') + '</span>';
      d.querySelector('.pn-suppr').addEventListener('click', function () { lignes.splice(k, 1); changer(); });
      d.appendChild(puces(v, function (j) { lignes[k] = j; dernier = j; dessiner(); synchro(); }));
      liste.appendChild(d);
    });
    if (p % 2 === 1) {
      var plus = document.createElement('button'); plus.type = 'button'; plus.className = 'pn-plus';
      plus.innerHTML = '<span>+</span> Ajouter un 2ᵉ coffret <em>(le 3ᵉ est offert)</em>';
      plus.addEventListener('click', function () { lignes.push(dernier); changer(); });
      liste.appendChild(plus);
    }
    // A basket edited outside the ABBOX drawer may still lack its eligible gift.
    if (p > 0 && f < Math.floor(p / 2)) {
      var choisirCadeau = document.createElement('button');
      choisirCadeau.type = 'button'; choisirCadeau.className = 'pn-plus';
      choisirCadeau.textContent = 'Choisir mon coffret offert';
      choisirCadeau.addEventListener('click', function () { changer(); });
      liste.appendChild(choisirCadeau);
    }
    cadeaux.forEach(function (v, k) {
      var d = document.createElement('div'); d.className = 'pn-ligne pn-cadeau' + (anime ? '' : ' fixe');
      d.innerHTML = '<div class="pn-haut">' + vignette(v, true) +
        '<div class="pn-infos"><span class="pn-etiquette">Offert' + (f > 1 ? ' n°' + (k + 1) : '') + '</span><span class="fr">' + V[v].nom + '</span><span class="fr pn-prix"><s>' + euros(PRIX) + '</s> 0,00 €</span></div></div>' +
        '<span class="fr pn-choix">Choisis ton coffret offert</span>';
      d.appendChild(puces(v, function (j) { cadeaux[k] = j; dessiner(); synchro(); }));
      liste.appendChild(d);
    });
    var txt = !p ? '2 coffrets achetés = le 3ᵉ offert, au choix.' : p % 2 === 1 ? 'Ajoute un 2ᵉ coffret : le 3ᵉ est offert et tu le choisis !' : (f > 1 ? f + ' coffrets offerts : choisis-les ci-dessous.' : 'Ton 3ᵉ coffret est offert : choisis-le ci-dessous.');
    document.getElementById('pn-obj-txt').textContent = txt;
    document.getElementById('pn-jauge-barre').style.width = (!p ? 0 : p % 2 === 1 ? 50 : 100) + '%';
    document.getElementById('pn-sous').textContent = euros((p + f) * PRIX);
    document.getElementById('pn-offert-ligne').style.display = f ? 'flex' : 'none';
    document.getElementById('pn-offert-txt').textContent = f > 1 ? f + ' coffrets offerts' : '3ᵉ coffret offert';
    document.getElementById('pn-offert').textContent = '−' + euros(f * PRIX);
    var total = p * PRIX;
    document.getElementById('pn-total').textContent = euros(total);
    document.getElementById('pn-commander-txt').textContent = p ? 'Passer commande · ' + euros(total) : 'Passer commande';
    document.getElementById('pn-commander').disabled = !p; actualiserCommande();
  }
  function nombre() { return payes() + cadeaux.length; }
  function cibles() { return Array.prototype.slice.call(document.querySelectorAll('#site a.btn, #site a[aria-label="Panier"]')).filter(function (a) { return a.classList.contains('btn') ? a.textContent.indexOf('Panier') === 0 : true; }); }
  function compteur(saute) {
    var n = nombre();
    cibles().forEach(function (a) {
      if (a.classList.contains('btn')) { a.textContent = 'Panier (' + n + ')'; }
      else {
        a.style.position = 'relative';
        var b = a.querySelector('.pn-badge');
        if (!b) { b = document.createElement('span'); b.className = 'pn-badge'; a.appendChild(b); }
        b.textContent = n; b.style.display = n ? 'block' : 'none';
      }
      if (saute) { a.classList.remove('pn-saute'); void a.offsetWidth; a.classList.add('pn-saute'); }
    });
  }
  function voler(depuis, fin) {
    var r = depuis.getBoundingClientRect();
    var c = cibles()[0], rc = c ? c.getBoundingClientRect() : null;
    var x2 = rc && rc.bottom > 0 ? rc.left + rc.width / 2 : window.innerWidth - 40, y2 = rc && rc.bottom > 0 ? rc.top + rc.height / 2 : 30;
    var d = document.createElement('div'); d.className = 'pn-vole';
    var x1 = r.left + r.width / 2 - 17, y1 = r.top + r.height / 2 - 14;
    d.style.left = x1 + 'px'; d.style.top = y1 + 'px';
    document.body.appendChild(d);
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.style.transform = 'translate(' + (x2 - x1 - 17) + 'px,' + (y2 - y1 - 14) + 'px) scale(0.4) rotate(-20deg)'; d.style.opacity = '0.2'; }); });
    setTimeout(function () { d.remove(); fin(); }, 760);
  }
  function ajouter(v, lot, depuis) {
    dernier = v;
    lignes.push(v); if (lot) lignes.push(v);
    fusionner(); caler();
    var operation = synchro();
    var apres = function () { dessiner(); compteur(true); setTimeout(ouvrir, 120); };
    if (depuis) voler(depuis, apres); else apres();
    return operation;
  }
  window.ABBOX_PANIER = { ajouter: ajouter, ouvrir: ouvrir, compteur: compteur };
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button');
    if (!el || el.closest('#pn') || el.id === 'barre-ajout') return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (el.closest('#site') && (t.indexOf('Panier (') === 0 || el.getAttribute('aria-label') === 'Panier')) { e.preventDefault(); e.stopImmediatePropagation(); dessiner(); ouvrir(); return; }
    if (window.ABBOX_SHOP.page !== 'produit') return;
    var etat = window.ABBOX_ETAT ? window.ABBOX_ETAT() : null; if (!etat) return;
    if (t.indexOf('Prendre le lot') === 0) { e.preventDefault(); e.stopImmediatePropagation(); if (window.ABBOX_LOT) window.ABBOX_LOT(1); ajouter(etat.c, true, el); return; }
    if (t.indexOf('Ajouter au panier') === 0) { e.preventDefault(); e.stopImmediatePropagation(); ajouter(etat.c, etat.l === 1, el); }
  }, true);
  dessiner();
})();
;

(function () {
  var mn = document.getElementById('mn');
  function ouvrir() { mn.classList.add('ouvert'); mn.setAttribute('aria-hidden', 'false'); Array.prototype.forEach.call(mn.querySelectorAll('nav a'), function (a, i) { a.style.transitionDelay = (0.12 + i * 0.05) + 's'; }); }
  function fermer() { mn.classList.remove('ouvert'); mn.setAttribute('aria-hidden', 'true'); }
  document.getElementById('mn-fermer').addEventListener('click', fermer);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[aria-label="Menu"]');
    if (b && b.closest('#site')) { e.preventDefault(); ouvrir(); return; }
    var l = e.target.closest && e.target.closest('#mn a'); if (l) setTimeout(fermer, 60);
    var s = e.target.closest && e.target.closest('button[aria-label="S\'inscrire"]');
    if (s) {
      var champ = s.parentNode.querySelector('input[type="email"]'); var v = champ ? champ.value.trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { if (champ) { champ.focus(); champ.placeholder = 'Entre un e-mail valide'; } return; }
      var m = document.createElement('span'); m.className = 'nl-merci'; m.textContent = 'Merci ! Tu recevras nos offres en avant-première.';
      champ.style.display = 'none'; s.style.display = 'none'; s.parentNode.appendChild(m);
      fetch('/contact', { method: 'POST', body: new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': v, 'contact[tags]': 'newsletter', 'contact[accepts_marketing]': 'true' }) }).catch(function () {});
    }
  }, true);
})();
;

(function () {
  var h = preact.h, rendre = preact.render;
  var DONNEES = JSON.parse(document.getElementById('donnees').textContent);
  var site = document.getElementById('site');
  var courant = null, cleCourante = null, prevu = false;

  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (o) { Object.assign(this.state, typeof o === 'function' ? o(this.state) : o); planifier(); };
  DCLogic.prototype.forceUpdate = function () { planifier(); };

  function lire(scope, chemin) {
    chemin = chemin.trim();
    if (chemin === 'true') return true; if (chemin === 'false') return false;
    var v = scope, parts = chemin.split('.');
    for (var i = 0; i < parts.length; i++) { if (v == null) return undefined; v = v[parts[i]]; }
    return v;
  }
  var TROU = /\{\{\s*([^}]+?)\s*\}\}/g, SEUL = /^\{\{\s*([^}]+?)\s*\}\}$/;
  function texte(s, scope) { return s.replace(TROU, function (_, p) { var v = lire(scope, p); return v == null || typeof v === 'function' ? '' : String(v); }); }
  var EVTS = { onclick: 'onClick', onmouseenter: 'onMouseEnter', oninput: 'onInput', onchange: 'onChange' };

  function construire(noeud, scope, sortie) {
    var enfants = noeud.childNodes;
    for (var i = 0; i < enfants.length; i++) {
      var n = enfants[i];
      if (n.nodeType === 3) { var t = n.textContent; if (/^\s*$/.test(t) && t.indexOf('\n') >= 0) continue; sortie.push(texte(t, scope)); continue; }
      if (n.nodeType !== 1) continue;
      var tag = n.localName;
      if (tag === 'sc-for') {
        var liste = lire(scope, n.getAttribute('list').replace(/[{}]/g, '')) || [], as = n.getAttribute('as');
        liste.forEach(function (item, j) { var sc = Object.create(scope); sc[as] = item; sc.$index = j; construire(n, sc, sortie); });
        continue;
      }
      if (tag === 'sc-if') { if (lire(scope, n.getAttribute('value').replace(/[{}]/g, ''))) construire(n, scope, sortie); continue; }
      var props = {};
      for (var a = 0; a < n.attributes.length; a++) {
        var at = n.attributes[a], nom = at.name, val = at.value;
        if (nom.indexOf('hint-') === 0) continue;
        var m = val.match(SEUL);
        var v = m ? lire(scope, m[1]) : texte(val, scope);
        if (EVTS[nom]) { if (typeof v === 'function') props[EVTS[nom]] = v; continue; }
        if (nom === 'value') { props.value = v == null ? '' : v; continue; }
        props[nom] = v;
      }
      var sous = [];
      construire(n.content || n, scope, sous);
      sortie.push(h(tag, props, sous));
    }
  }

  function planifier() { if (prevu) return; prevu = true; var fait = function () { if (!prevu) return; prevu = false; peindre(); }; requestAnimationFrame(fait); setTimeout(fait, 60); }
  function peindre() {
    if (!courant) return;
    var vals = courant.inst.renderVals(), sortie = [];
    construire(courant.tpl.content, vals, sortie);
    rendre(h('div', { id: courant.mobile ? 'site-mobile' : 'site-ordi' }, sortie), site);
    if (window.ABBOX_PANIER) window.ABBOX_PANIER.compteur();
  }

  function monter(cle) {
    if (cle === cleCourante) return;
    if (courant) { try { courant.inst.componentWillUnmount && courant.inst.componentWillUnmount(); } catch (e) {} rendre(null, site); }
    cleCourante = cle;
    var d = DONNEES[cle];
    document.getElementById('style-page').textContent = d.style;
    var Classe = new Function('DCLogic', d.js + '\nreturn Component;')(DCLogic);
    var inst = new Classe({});
    courant = { inst: inst, tpl: document.getElementById('tpl-' + cle), mobile: /mobile$/.test(cle) };
    peindre();
    if (inst.componentDidMount) inst.componentDidMount();
    if (/^produit/.test(cle) && window.ABBOX_V == null && window.ABBOX_SHOP.v >= 0) window.ABBOX_V = window.ABBOX_SHOP.v;
    if (/^produit/.test(cle) && window.ABBOX_V != null && inst.choisirVariante) { inst.choisirVariante(window.ABBOX_V); window.ABBOX_V = null; }
    ajuster();
  }

  window.ABBOX_ETAT = function () {
    if (!courant || !/^produit/.test(cleCourante)) return null;
    var st = courant.inst.state || {}; var lots = ['34,90 €', '69,80 €'];
    return { c: st.c != null ? st.c : 0, prix: lots[st.l || 0], l: st.l || 0 };
  };
  window.ABBOX_LOT = function (j) { if (courant && /^produit/.test(cleCourante) && courant.inst.choisirQte) { courant.inst.choisirQte(j); } };
  window.ABBOX_CHOIX = function (i) { if (courant && /^produit/.test(cleCourante)) { if (courant.inst.choisirVariante) { courant.inst.choisirVariante(i); } else { courant.inst.setState({ c: i }); } } };
  function ajuster() {
    var ordi = window.innerWidth >= 760;
    var z = ordi ? Math.min(window.innerWidth / 1440, 1.6) : 1;
    site.style.zoom = ordi ? String(z) : '';
    site.style.marginLeft = ordi && window.innerWidth > 1440 * z + 1 ? ((window.innerWidth - 1440 * z) / 2 / z) + 'px' : '';
  }
  function route() {
    var ordi = window.innerWidth >= 760;
    var produit = window.ABBOX_SHOP.page === 'produit';
    monter((produit ? 'produit-' : 'accueil-') + (ordi ? 'ordi' : 'mobile'));
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    var mm = href.match(/^([\w-]+)\.dc\.html(#[\w-]+)?$/);
    if (mm) {
      e.preventDefault();
      var produit = /Produit/.test(mm[1]);
      var v = a.getAttribute('data-v');
      if (produit && v != null) window.ABBOX_V = parseInt(v, 10);
      var ici = window.ABBOX_SHOP.page === 'produit';
      if (produit) {
        var vv = window.ABBOX_V != null ? window.ABBOX_V : 0;
        var memeProduit = ici && courant && courant.inst.state && ((courant.inst.state.c || 0) < 2) === (vv < 2);
        if (!ici || (!memeProduit && window.ABBOX_V == null)) { location.href = window.ABBOX_SHOP.urls[vv < 2 ? 0 : 1] + '?variant=' + window.ABBOX_SHOP.ids[vv]; return; }
      } else if (ici) { location.href = '/' + (mm[2] || ''); return; }
      if (produit && window.ABBOX_V != null && courant && courant.inst.choisirVariante) { courant.inst.choisirVariante(window.ABBOX_V); window.ABBOX_V = null; }
      var ancre = mm[2];
      setTimeout(function () { var c = ancre && site.querySelector(ancre); if (c) c.scrollIntoView({ behavior: 'smooth', block: 'start' }); else window.scrollTo(0, 0); }, ancre ? 350 : 0);
      return;
    }
    if (href === '#') { e.preventDefault(); return; }
    if (href.charAt(0) === '#') {
      e.preventDefault();
      var cible = site.querySelector(href);
      if (cible) cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, true);
  
  window.addEventListener('resize', function () { route(); ajuster(); });
  route();
})();

document.addEventListener('input', function (e) { if (e.target && e.target.id === 'abbox-mot') { try { sessionStorage.setItem('abbox-mot', e.target.value); } catch (x) {} } });

/* ABBOX_CART_ENTRY_20261014: reuse the existing ABBOX drawer for /cart. */
(function () {
  var url = new URL(window.location.href);
  if (url.searchParams.get("abbox_panier") !== "1" || !window.ABBOX_PANIER) return;
  window.ABBOX_PANIER.ouvrir();
  url.searchParams.delete("abbox_panier");
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
})();
